import React from "react";
const SparePartsList = ({ spareParts }) => {
    if (!spareParts || spareParts.length === 0) {
      return <p className="text-center text-gray-500">No spare parts available.</p>;
    }
  
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {spareParts.map((part) => (
          <div key={part._id} className="border p-4 rounded-lg shadow-md">
            <img src={part.primaryImage} alt={part.name} className="w-full h-48 object-cover rounded" />
            <h3 className="text-xl font-bold mt-2">{part.name}</h3>
            <p className="text-gray-700">{part.description}</p>
            <p className="text-green-600 font-semibold">{part.price} CFA</p>
            <p className="text-sm text-gray-500">Compatible with: {part.compatibility?.join(", ")}</p>
          </div>
        ))}
      </div>
    );
  };
  export default SparePartsList;